import { Inject, Injectable } from '@angular/core';
import {CRUD_FORM__QUERY_SERVICE_INSTANCE, CRUD_FORM_ENDPOINT, CRUD_FORM_FLUX_ENDPOINT, GET_DATA_FORM_ENDPOINT} from '../survey.config';
import { ApiService } from 'src/app/core/services/api.service';
import { SnackbarService } from '../../../../core/services/snackbar-psa.service';  // Import MatSnackBar
import { QueryService } from 'src/app/core/services/query.service';
import { CrudService } from 'src/app/core/services/crud.service';
import { SurveySaveForm } from '../models/crud-survey.model';
import { CrudFluxService } from 'src/app/core/services/crud-flux.service';
import { ApiFluxService } from 'src/app/core/services/api-flux.service';


@Injectable({
  providedIn: 'root'
})
export class SurveyCrudFormFluxService extends CrudFluxService<SurveySaveForm> {

  constructor(
    @Inject(CRUD_FORM__QUERY_SERVICE_INSTANCE) public readonly query: QueryService<SurveySaveForm>,
    public readonly apiService:ApiFluxService,
    protected  override readonly snackbar : SnackbarService
    //@Inject(SnackbarService) protected override readonly snackbar: SnackbarService

  ) {
    // Chiamare il costruttore della classe padre con i parametri necessari
    super(CRUD_FORM_FLUX_ENDPOINT, apiService, snackbar);
  }

 get<SurveySaveForm>(id:string, tipoForm:string){
  return this.apiService.get<SurveySaveForm>(`${CRUD_FORM_FLUX_ENDPOINT}?id=${id}&tipoForm=${tipoForm}`)
  }

  getFormData<SurveySaveForm>(idPsa:string, tipoForm:string){
    return this.apiService.get<SurveySaveForm>(`${GET_DATA_FORM_ENDPOINT}?idPsa=${idPsa}&tipoForm=${tipoForm}`, 0, true)
  }

  countElementInForm<SurveySaveForm>(idPsa:string, tipoForm:string){
    return this.apiService.get<SurveySaveForm>(`${CRUD_FORM_FLUX_ENDPOINT}/count?idPsa=${idPsa}&tipoForm=${tipoForm}`, 0, true)
  }

  getPreviousNominativiInForm(idPsa:string, tipoForm:string){
    return this.apiService.get<any>(`${CRUD_FORM_FLUX_ENDPOINT}/nominativi?idPsa=${idPsa}&tipoForm=${tipoForm}`, 0, true)
  }


  getPreviousFormData<SurveySaveForm>(idPsa:string, tipoForm:string){
    return this.apiService.get<SurveySaveForm>(`${CRUD_FORM_FLUX_ENDPOINT}?id=${idPsa}&tipoForm=${tipoForm}`, 0, true)
  }
}
